import getNoCategoryDishes from "./getNoCategoryDishes";
/**
 *
 * @param {Object} payload payload
 * @param {Object} payload.question menu insight question
 * @param {Array} payload.products products currently available
 *
 * @returns {Array} array of 'dishes' based on major group
 *
 */

function getEposDishes(_ref) {
  var question = _ref.question,
      products = _ref.products;
  return getNoCategoryDishes({
    question: question,
    products: products
  });
}

export default getEposDishes;